import { ref as r, computed as c, onMounted as s } from "vue";
const e = r("Desktop"), d = c(() => ["Android", "iOS"].includes(e.value || "")), o = () => {
  const { userAgent: t, platform: i, maxTouchPoints: n } = navigator || {};
  if (/android/i.test(t)) {
    e.value = "Android";
    return;
  }
  if (/iPad|iPhone|iPod/.test(t) || /macintel/i.test(i) && n > 0) {
    e.value = "iOS";
    return;
  }
  e.value = "Desktop";
}, a = () => (o(), e.value), v = () => (s(() => {
  o();
}), e);
export {
  e as device,
  a as getDevice,
  d as isMobile,
  v as useDetectDevice
};
